// Label status batal Shopee (dari backend `shopee_cancelled` / `shopee_in_cancel`) untuk semua antrean divisi.
export function ShopeeCancelTag({ job, id }) {
  const key = id || job?.id || job?.order_number;
  if (job?.shopee_cancelled) return <div className="shp-cancel-tag is-cancelled" data-testid={`shopee-cancel-tag-${key}`}>
    <b>DIBATALKAN SHOPEE — JANGAN PRODUKSI</b> · Tidak bisa dicetak. Tangani lewat HOLD / Pembatalan Shopee.</div>;
  if (job?.shopee_in_cancel) return <div className="shp-cancel-tag is-pending" data-testid={`shopee-incancel-tag-${key}`}>
    <b>PEMBELI MENGAJUKAN BATAL</b> · Ikuti keputusan HOLD sebelum melanjutkan.</div>;
  return null;
}
